export default {
    created() {
        this.getConnections();
    },

    data() {
        return {
            connections: []
        };
    },

    methods: {
        getConnections() {
            axios.get('/ajax/connections')
                .then(response => {
                    this.$set(this, 'connections', response.data);
                })
                .catch(error => {
                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        },

        openLabelColorPicker() {
            this.$set(this, 'showColorPicker', true);
        },

        closeLabelColorPicker() {
            this.$set(this, 'showColorPicker', false);
        }
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Sources.js